export default "/images/photo-3.png?0e0c742006dc5fdb4341c01090f3330d";